import { XsBaseClass } from "./base.class";


export class XsColorStore extends XsBaseClass {

  debugId:string = 'COLOR_STORE';
  debug = false;
  
  // copy of the plugin's controls
  controls:any = null;

  // reference to the colorManager (but try to remove this in the future)
  colorManager:any = null;

  // our caches
  colorsCache:any = {
    _resolutions: {}
  };
  renderedColorsCache:any = {};

  // our palette index lookup table
  paletteLut:number[] = null;


  constructor ( config:any = {} ) {
    super(config);
    if ( config.controls ) {
      this.controls = config.controls;
    }
    if ( config.colorManager ) {
      this.colorManager = config.colorManager;
    }
    if ( config.paletteLut ) {
      this.paletteLut = config.paletteLut;
    }
    // console.log( this.debugId + ' :: CONSTRUCTOR',this.controls,this.colorManager,this.paletteLut);
  }

  getName ( name:string = '__current' ) {
    if ( !name || name == '__current' ) {
        return this.controls.kind.value;
    }
    return name;
  }

  getResolution ( resolution:any = null ) {
    if ( !resolution ) {
      resolution = 100;
    }
    return parseInt(resolution);
  }

  getIndex ( name:string = '__current', resolution:any = null ) {
    if ( !name || name == '__current' ) {
      name = this.controls.kind.value;
    }
    resolution = this.getResolution(resolution);
    if ( !resolution || resolution == 'null' ) {
      return null;
    }
    return 'key_' + name + '_' + resolution;
  }

  resetColor( name:string = '__current' ) {
    name = this.getName(name);
    if ( this.debug ) { console.log('@@resetColor('+name+')', this.colorsCache['_resolutions'] ); }
    // go through all resolutions and delete their cache entry
    if ( this.colorsCache._resolutions && this.colorsCache._resolutions[name] ) {
      Object.keys( this.colorsCache._resolutions[name] ).forEach ( key => {
        let resolution = this.getResolution( key.substr(4) );
        const idx = this.getIndex(name,resolution);
        if ( this.colorsCache[idx] ) {
          this.colorsCache[idx] = null;
            delete this.colorsCache[idx];
        }
        if ( this.debug ) { console.log('@@resetColor('+name+') IDX', name, key, resolution, idx ); }
      });
      this.colorsCache._resolutions[name] = null;
      delete this.colorsCache._resolutions[name];
    }
    if ( this.debug ) { console.log('@@resetColor('+name+') DONE', this.colorsCache ); }
    // if ( this.colorsCache[idx+'_original'] ) {
    //     delete this.colorsCache[idx+'_original'];
    // }
  }

  getColors ( name:string = '__current', resolution:number = null, getOriginal:boolean = false ) {
    name = this.getName(name);
    const idx = this.getIndex(name,resolution);
    if ( !name || !idx) {
      return null;
    }
    if ( this.debug ) { console.log('@@getColors('+name+')', idx, this.colorsCache[idx] ? true : false ); }
    if ( !this.colorsCache[idx] ) {
        this.setColors( name, resolution, this.colorManager.getColors( name, { items: resolution } ) );
    }
    if ( this.debug ) { console.log('@@getColors('+name+') DONE',idx,getOriginal, this.colorsCache[idx]); }
    if ( getOriginal ) {
      return this.colorsCache[idx+'_original'];
    }
    return this.colorsCache[idx];
  }

  setColors ( name:string = '__current', resolution:number = null, colors:any = [] ) {
    name = this.getName(name);
    resolution = this.getResolution(resolution);
    const idx = this.getIndex(name,resolution);
    if ( !name || !idx) {
      return null;
    }
    this.colorsCache[idx] = [ ...colors ];
    if ( !this.colorsCache._resolutions[name] ) {
      this.colorsCache._resolutions[name] = {};
    }
    this.colorsCache._resolutions[name]['key_'+resolution] = true;
    if ( !this.colorsCache[idx+'_original'] ) {
      // make a copy of the original
        this.colorsCache[idx+'_original'] = [ ...colors ];
    }
    if ( this.debug ) { console.log('@@setColors('+name+')', resolution, idx ); }
  }
/*
  processThese ( name:string = '__current', resolution:number = null ) {
    name = this.getName(name);
    if ( !resolution ) {
      return Object.keys(this.colorsCache._resolutions[name]).map( k => { parseInt(k) });
    } 
    return [ resolution ];
  }
*/

  // bridge the colorStore to the colorManager
  getPaletteLut ( name:string = '__current' ) {
    name = this.getName(name);
    const test = this.colorManager.getPaletteLut(name);
    if ( this.debug ) { console.log('@@getPaletteLut('+name+')',test); }
    return test;
  }

  // bridge the colorStore to the colorManager
  setPaletteLut ( name:string = '__current', lut:number[] = [] ) {
    name = this.getName(name);
    this.colorManager.setPaletteLut(name,[ ...lut ]);
    if ( this.debug ) { console.log('@@setPaletteLut('+name+')',lut); }
  }


  // process the index (for various orders of the colors)

  resetColors ( name:string = '__current' ) {
    name = this.getName(name);
    let lut = this.getPaletteLut(name);
    lut.sort( function(a, b) { return a - b; } );
    this.setPaletteLut( name, lut );
    this.resetColor(name);
  }

  reverseColors ( name:string = '__current' ) {
    name = this.getName(name);
    let lut = this.getPaletteLut(name);
    lut = lut.reverse();
    this.setPaletteLut(name,lut);
    this.resetColor(name);
    /*
    name = this.getName(name);
    this.processThese ( name, resolution ).forEach ( key => {
      let colors = this.getColors(name,key);
      console.log('!reverseColor()', name, key, colors );
      if ( colors ) {
        this.setColors( name, key, colors.reverse() );
      }
      console.log('!reverseColor() DONE', name, key, this.getColors( name, key ) );
    });
    */
  }

  randomizeColors ( name:string = '__current' ) {
    name = this.getName(name);
    let lut = this.getPaletteLut(name);
    lut = this.colorManager.randomizeArray(lut);
    this.setPaletteLut( name, lut );
    this.resetColor(name);
    /*
    name = this.getName(name);
    this.processThese ( name, resolution ).forEach ( key => {
      let colors = this.getColors(name,key);
      console.log('!randomizeColor()', name, key, colors );
      if ( colors ) {
        colors = this.colorManager.randomizeArray(colors);
        this.setColors( name, resolution, colors );
      }
      console.log('!randomizeColor() DONE', name, key, this.getColors( name, key ) );
    });
    */
  }

  getRenderedColors ( name:string = '__current', renderMode:string = 'cesium', reset:boolean = false ) {
    name = this.getName(name);
    const idx = this.getIndex(name);
  }

  setRenderedColors ( name:string = '__current', renderMode:string = 'cesium', colors:any, reset:boolean = false ) {
    name = this.getName(name);
      const idx = this.getIndex(name);
  }
}
